'use client';

import { c as _c } from "react/compiler-runtime";
import appStoreLogoEn from '@public/images/app_store.svg';
import appStoreLogoFr from '@public/images/app_store_fr.svg';
import googlePlayLogoEn from '@public/images/google_play.svg';
import googlePlayLogoFr from '@public/images/google_play_fr.svg';
import Image from 'next/image';
import React from 'react';
import { Button } from '@src/components/Button/Button';
import { LocalizedLink } from '@src/components/LocalizedLink/LocalizedLink';
import { useUserAgent } from '@src/hooks/useUserAgent';
import { useLocale } from '@src/i18n/LocaleProvider';
import { useTrackSelectCta } from '@src/utils/analytics.util';
import { cn } from '@src/utils/tailwind';
interface Props {
  className?: string;
  title: string;
  titleClassName?: string;
  description: string;
  descriptionClassName?: string;
  defaultLink: string;
  iosLink: string;
  androidLink: string;
  buttonText: string;
  buttonClassName?: string;
}
export function AppLink(t0) {
  const $ = _c(43);
  const {
    className,
    defaultLink,
    iosLink,
    androidLink,
    title,
    titleClassName,
    description,
    descriptionClassName,
    buttonText,
    buttonClassName
  } = t0;
  const {
    locale
  } = useLocale();
  const trackSelectCta = useTrackSelectCta();
  const userAgent = useUserAgent();
  const osName = userAgent?.os?.name;
  const isIOS = osName === "iOS";
  const isAndroid = osName === "Android";
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      en: appStoreLogoEn,
      fr: appStoreLogoFr
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const appStoreLogo = t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      en: googlePlayLogoEn,
      fr: googlePlayLogoFr
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const googlePlayLogo = t2;
  let linkHref;
  if ($[2] !== androidLink || $[3] !== defaultLink || $[4] !== iosLink || $[5] !== isAndroid || $[6] !== isIOS) {
    linkHref = defaultLink;
    if (isIOS) {
      linkHref = iosLink;
    } else {
      if (isAndroid) {
        linkHref = androidLink;
      }
    }
    $[2] = androidLink;
    $[3] = defaultLink;
    $[4] = iosLink;
    $[5] = isAndroid;
    $[6] = isIOS;
    $[7] = linkHref;
  } else {
    linkHref = $[7];
  }
  let t3;
  if ($[8] !== className) {
    t3 = cn(["text-center"], className);
    $[8] = className;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== titleClassName) {
    t4 = cn("text-heading-display-3 md:text-heading-3 font-medium", titleClassName);
    $[10] = titleClassName;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== t4 || $[13] !== title) {
    t5 = <div className={t4}>{title}</div>;
    $[12] = t4;
    $[13] = title;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== descriptionClassName) {
    t6 = cn("mx-auto mt-1 w-[313px] text-body-sm md:w-auto", descriptionClassName);
    $[15] = descriptionClassName;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== description || $[18] !== t6) {
    t7 = <div className={t6}>{description}</div>;
    $[17] = description;
    $[18] = t6;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] !== isIOS || $[21] !== locale) {
    t8 = isIOS && <Image className="mx-auto mt-3.5 w-[202px]" src={appStoreLogo[locale.lang]} alt="app-store-logo" />;
    $[20] = isIOS;
    $[21] = locale;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  let t9;
  if ($[23] !== isAndroid || $[24] !== locale) {
    t9 = isAndroid && <Image className="mx-auto mt-3.5 w-[202px]" src={googlePlayLogo[locale.lang]} alt="google-play-logo" />;
    $[23] = isAndroid;
    $[24] = locale;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  let t10;
  if ($[26] !== buttonClassName || $[27] !== buttonText || $[28] !== isAndroid || $[29] !== isIOS || $[30] !== linkHref || $[31] !== trackSelectCta) {
    t10 = !isIOS && !isAndroid && <Button data-testid="applink-button" size="medium" className={cn("mt-6 max-w-[169px]", buttonClassName)} onClick={() => {
      trackSelectCta({
        "cta url": linkHref
      });
    }}>{buttonText?.toUpperCase()}</Button>;
    $[26] = buttonClassName;
    $[27] = buttonText;
    $[28] = isAndroid;
    $[29] = isIOS;
    $[30] = linkHref;
    $[31] = trackSelectCta;
    $[32] = t10;
  } else {
    t10 = $[32];
  }
  let t11;
  if ($[33] !== linkHref || $[34] !== t10 || $[35] !== t8 || $[36] !== t9) {
    t11 = <LocalizedLink href={linkHref}>{t8}{t9}{t10}</LocalizedLink>;
    $[33] = linkHref;
    $[34] = t10;
    $[35] = t8;
    $[36] = t9;
    $[37] = t11;
  } else {
    t11 = $[37];
  }
  let t12;
  if ($[38] !== t11 || $[39] !== t3 || $[40] !== t5 || $[41] !== t7) {
    t12 = <div className={t3}>{t5}{t7}{t11}</div>;
    $[38] = t11;
    $[39] = t3;
    $[40] = t5;
    $[41] = t7;
    $[42] = t12;
  } else {
    t12 = $[42];
  }
  return t12;
}